export enum ChartType {
  Sunburst = 'sunburst',
  StackedBarChart = 'stackedColumn',
  WorldMap = 'worldMap',
  PieChart = 'pieChart',
  Iframe = 'iframe',
  BarChart = 'barChart',
  ScatterPlot = 'plotArea'
}
